var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "search",
    width: 188.496,
    height: 223.669,
    viewBox: "0 0 188.496 223.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_84",
    d: "M0 0H188.496V223.669H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    d: "M94.249 0A94.248 94.248 0 1 0 188.5 94.249 94.248 94.248 0 0 0 94.249 0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-6,.cls-9{fill:none}.cls-2{clip-path:url(#clip-path)}.cls-3{fill:#fff}.cls-5{fill:#31f4cf}.cls-6,.cls-9{stroke:#2c365e;stroke-miterlimit:10;stroke-width:.5px}.cls-7{fill:#2b5889}.cls-8{fill:#f6c9a2}.cls-9{stroke-linecap:round}.cls-10{fill:#2c365e}.cls-11{fill:#2dd3b3}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    d: "M188.5 94.248A94.249 94.249 0 1 0 94.249 188.5 94.249 94.249 0 0 0 188.5 94.248",
    className: "cls-3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    d: "M131.375 176.884s-11.737-54.139-15.736-66.946a34.9 34.9 0 0 0-3.874-8.6h1.423l-7.806-7.806a72.342 72.342 0 0 1-18.047 2 104.991 104.991 0 0 1-13.183-1.264l-6.412-.74-.823 3.052-.617.02.247 1.357-.913 3.389h1.521l13.276 73.716z",
    className: "cls-5",
    transform: "translate(-.003 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    d: "M131.375 176.884s-11.737-54.139-15.736-66.946a34.9 34.9 0 0 0-3.874-8.6h1.423l-7.806-7.806a72.342 72.342 0 0 1-18.047 2 104.991 104.991 0 0 1-13.183-1.264l-6.412-.74-.823 3.052-.617.02.247 1.357-.913 3.389h1.521l13.276 73.716z",
    className: "cls-6",
    transform: "translate(-.003 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    d: "M80.428 175.057l8.866 48.365 23.738-.428-10.185-49.447z",
    className: "cls-7",
    transform: "translate(-.003 -.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    d: "M80.428 175.057l8.866 48.365 23.738-.428-10.185-49.447z",
    className: "cls-6",
    transform: "translate(-.003 -.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    d: "M89.508 103.027h-1.646a4.382 4.382 0 0 1-4.383-4.382V85.919H93.9v12.716a4.392 4.392 0 0 1-4.392 4.392z",
    className: "cls-8",
    transform: "translate(-.004 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    d: "M89.508 103.027h-1.646a4.382 4.382 0 0 1-4.383-4.382V85.919H93.9v12.716a4.392 4.392 0 0 1-4.392 4.392z",
    className: "cls-9",
    transform: "translate(-.004 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    d: "M83.479 92.45s.946 2.887 5.207 4.162 5.207.28 5.207.28V92.45z",
    className: "cls-10",
    transform: "translate(-.004 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    d: "M88.686 61.6c-12.7 0-11.483 7.691-11.483 7.691v15.632c0 8.908 11.483 9.279 11.483 9.279s11.482-.37 11.482-9.279V69.295s1.218-7.695-11.482-7.695",
    className: "cls-8",
    transform: "translate(-.003 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    d: "M88.686 61.6c-12.7 0-11.483 7.691-11.483 7.691v15.632c0 8.908 11.483 9.279 11.483 9.279s11.482-.37 11.482-9.279V69.295s1.218-7.695-11.482-7.695z",
    className: "cls-9",
    transform: "translate(-.003 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    d: "M85.552 67.016s3.824 4.238 14.615 4.238l.033 3.874 2.477-.839a82.14 82.14 0 0 1-.921-9.715c0-3.751-5.9-5.519-13.712-5.519s-12.42 3.331-12.42 6.177-.723 8.876-.723 8.876l2.279 1.16V69.3c0-.008 2.92.889 8.373-2.287",
    className: "cls-10",
    transform: "translate(-.003 -.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    d: "M85.552 67.016s3.824 4.238 14.615 4.238l.033 3.874 2.477-.839a82.14 82.14 0 0 1-.921-9.715c0-3.751-5.9-5.519-13.712-5.519s-12.42 3.331-12.42 6.177-.723 8.876-.723 8.876l2.279 1.16V69.3c-.001-.005 2.92.892 8.372-2.284z",
    className: "cls-6",
    transform: "translate(-.003 -.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    d: "M100.2 74.1s2.2-1.3 2.961 1.1c.979 3.134-2.961 5.8-2.961 5.8z",
    className: "cls-8",
    transform: "translate(-.004 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    d: "M100.2 74.1s2.2-1.3 2.961 1.1c.979 3.134-2.961 5.8-2.961 5.8z",
    className: "cls-9",
    transform: "translate(-.004 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    d: "M77.179 74.1s-2.2-1.3-2.961 1.1c-.979 3.134 2.961 5.8 2.961 5.8z",
    className: "cls-8",
    transform: "translate(-.003 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    d: "M77.179 74.1s-2.2-1.3-2.961 1.1c-.979 3.134 2.961 5.8 2.961 5.8z",
    className: "cls-9",
    transform: "translate(-.003 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    d: "M88.415 76.089l-2.353 6.918a1.472 1.472 0 0 0 1.4 1.949h2",
    className: "cls-8",
    transform: "translate(-.004 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    d: "M88.415 76.089l-2.353 6.918a1.472 1.472 0 0 0 1.4 1.949h2",
    className: "cls-9",
    transform: "translate(-.004 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    d: "M130.386 172.329l-29.676-12.256s-7.871-1.884-10.669 6.128l-4.934 21.214-5.329 25.285 19.066 3.554 6.5-30.006 1 4.269s10.4-.247 18.079.016a8.042 8.042 0 0 0 8.086-10.044z",
    className: "cls-7",
    transform: "translate(-.003 -.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    d: "M130.386 172.329l-29.676-12.256s-7.871-1.884-10.669 6.128l-4.934 21.214-5.329 25.285 19.066 3.554 6.5-30.006 1 4.269s10.4-.247 18.079.016a8.042 8.042 0 0 0 8.086-10.044z",
    className: "cls-6",
    transform: "translate(-.003 -.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    d: "M56.606 120.478l-1.328 10.262-9.468-20.8H33l15.6 34.366a8.336 8.336 0 0 0 3.479 3.858c.033.016.066.041.107.058a8.445 8.445 0 0 0 9.2-.864c.436-.337.9-.707 1.365-1.069a8.556 8.556 0 0 0 3.224-6l1.563-18.869z",
    className: "cls-8",
    transform: "translate(-.001 -.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    d: "M56.606 120.478l-1.328 10.262-9.468-20.8H33l15.6 34.366a8.336 8.336 0 0 0 3.479 3.858c.033.016.066.041.107.058a8.445 8.445 0 0 0 9.2-.864c.436-.337.9-.707 1.365-1.069a8.556 8.556 0 0 0 3.224-6l1.563-18.869z",
    className: "cls-9",
    transform: "translate(-.001 -.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    d: "M74.151 94.268l-5.051-.847s-9.624-1.489-11.7 7.633l-5.82 20.925 15.8 4.146 3.49-16.418",
    className: "cls-5",
    transform: "translate(-.002 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    d: "M74.151 94.268l-5.051-.847s-9.624-1.489-11.7 7.633l-5.82 20.925 15.8 4.146 3.49-16.418",
    className: "cls-6",
    transform: "translate(-.002 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    d: "M132.842 112.659l5.84 8.546-.987-22.834 11.417-5.8 1.662 37.721a8.264 8.264 0 0 1-1.366 5.018c-.024.033-.041.066-.065.1a8.432 8.432 0 0 1-8.564 3.389c-.55-.107-1.152-.23-1.744-.345a8.512 8.512 0 0 1-5.568-3.874l-9.953-16.13z",
    className: "cls-8",
    transform: "translate(-.005 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    d: "M132.842 112.659l5.84 8.546-.987-22.834 11.417-5.8 1.662 37.721a8.264 8.264 0 0 1-1.366 5.018c-.024.033-.041.066-.065.1a8.432 8.432 0 0 1-8.564 3.389c-.55-.107-1.152-.23-1.744-.345a8.512 8.512 0 0 1-5.568-3.874l-9.953-16.13z",
    className: "cls-9",
    transform: "translate(-.005 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    d: "M102.81 94.145s11.031-4.1 15.43-.107 19.206 20.846 19.206 20.846l-14.139 9.871-6.392-9.237-5.371-7.675",
    className: "cls-5",
    transform: "translate(-.004 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    d: "M102.81 94.145s11.031-4.1 15.43-.107 19.206 20.846 19.206 20.846l-14.139 9.871-6.392-9.237-5.371-7.675",
    className: "cls-6",
    transform: "translate(-.004 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_117",
    d: "M0 10.669L2.69 0",
    className: "cls-9",
    transform: "translate(105.331 175.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    d: "M137.72 99.029a17.2 17.2 0 0 1 1.333-6.7c1.406-2.961 12.443-10.545 13.078-11.006 1.67-1.217 3.167.872 3.167.872L160.71 79a3.859 3.859 0 0 1 3.779 1.148c1.471 1.769 1.456 5.4.609 6.507s-10.167 7.847-10.167 7.847-3.924 3.907-5.4 7.123",
    className: "cls-8",
    transform: "translate(-.006 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    d: "M137.72 99.029a17.2 17.2 0 0 1 1.333-6.7c1.406-2.961 12.443-10.545 13.078-11.006 1.67-1.217 3.167.872 3.167.872L160.71 79a3.859 3.859 0 0 1 3.779 1.148c1.471 1.769 1.456 5.4.609 6.507s-10.167 7.847-10.167 7.847-3.924 3.907-5.4 7.123",
    className: "cls-9",
    transform: "translate(-.006 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    d: "M153.7 83.213a39.553 39.553 0 0 1 4.244 6.877",
    className: "cls-8",
    transform: "translate(-.006 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    d: "M153.7 83.213a39.553 39.553 0 0 1 4.244 6.877",
    className: "cls-9",
    transform: "translate(-.006 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    d: "M155.043 85.072a86.6 86.6 0 0 0 8.761-5.528",
    className: "cls-8",
    transform: "translate(-.007 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    d: "M155.043 85.072a86.6 86.6 0 0 0 8.761-5.528",
    className: "cls-9",
    transform: "translate(-.007 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_118",
    d: "M0 5.371L8.185 0",
    className: "cls-9",
    transform: "translate(157.464 83.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    d: "M165.094 81.2s-2.624 2.2-3.94 3.019-4.912 2.731-4.912 2.731",
    className: "cls-8",
    transform: "translate(-.007 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    d: "M165.094 81.2s-2.624 2.2-3.94 3.019-4.912 2.731-4.912 2.731",
    className: "cls-9",
    transform: "translate(-.007 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    d: "M47.277 113.318a36.286 36.286 0 0 0-2.73-7.165c-1.6-2.854-12.207-9.081-12.865-9.5-1.752-1.1-3.1 1.086-3.1 1.086l-5.617-2.8a3.844 3.844 0 0 0-3.686 1.4c-1.341 1.869-1.078 5.486-.157 6.532S29.807 110 29.807 110s4.541 3.562 6.243 6.671",
    className: "cls-8",
    transform: "translate(-.001 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    d: "M47.277 113.318a36.286 36.286 0 0 0-2.73-7.165c-1.6-2.854-12.207-9.081-12.865-9.5-1.752-1.1-3.1 1.086-3.1 1.086l-5.617-2.8a3.844 3.844 0 0 0-3.686 1.4c-1.341 1.869-1.078 5.486-.157 6.532S29.807 110 29.807 110s4.541 3.562 6.243 6.671",
    className: "cls-9",
    transform: "translate(-.001 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    d: "M30.243 98.644a39.494 39.494 0 0 0-3.759 7.156",
    className: "cls-8",
    transform: "translate(-.001 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    d: "M30.243 98.644a39.494 39.494 0 0 0-3.759 7.156",
    className: "cls-9",
    transform: "translate(-.001 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    d: "M29.033 100.586a86.611 86.611 0 0 1-9.122-4.911",
    className: "cls-8",
    transform: "translate(-.001 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    d: "M29.033 100.586a86.611 86.611 0 0 1-9.122-4.911",
    className: "cls-9",
    transform: "translate(-.001 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    d: "M28.581 97.748l8.621 5.511a5.159 5.159 0 0 0-.617 5.289",
    className: "cls-9",
    transform: "translate(-.001 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_119",
    d: "M8.53 4.796L0 0",
    className: "cls-9",
    transform: "translate(18.357 99.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    d: "M18.727 97.419s2.771 2.007 4.138 2.739 5.083 2.385 5.083 2.385",
    className: "cls-8",
    transform: "translate(-.001 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    d: "M18.727 97.419s2.771 2.007 4.138 2.739 5.083 2.385 5.083 2.385",
    className: "cls-9",
    transform: "translate(-.001 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_85",
    d: "M0 0H12.617V6.12H0z",
    className: "cls-11",
    transform: "translate(96.859 119.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_86",
    d: "M0 0H12.617V6.12H0z",
    className: "cls-6",
    transform: "translate(96.859 119.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    d: "M103.173 117.012a2.155 2.155 0 1 1-2.156 2.155 2.155 2.155 0 0 1 2.156-2.155",
    className: "cls-11",
    transform: "translate(-.004 -.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    d: "M103.173 117.012a2.155 2.155 0 1 1-2.156 2.155 2.155 2.155 0 0 1 2.156-2.155z",
    className: "cls-6",
    transform: "translate(-.004 -.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    d: "M93.1 88.023a5.466 5.466 0 0 1-4.64 2.32 6.9 6.9 0 0 1-5.1-2.32",
    className: "cls-6",
    transform: "translate(-.004 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_120",
    d: "M0 0L3.734 8.645",
    className: "cls-9",
    transform: "translate(55.272 130.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_121",
    d: "M0 0L0.666 9.525",
    className: "cls-9",
    transform: "translate(138.677 121.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    d: "M139.548 55.264l-.269-.713a11.155 11.155 0 0 0-6.5 14.376l.713-.268a10.4 10.4 0 0 1 6.059-13.4m15.886 5.12v.009a12.589 12.589 0 1 1 0-.009",
    className: "cls-3",
    transform: "translate(-.005 -.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    d: "M155.437 60.394v-.009a14.372 14.372 0 1 0 0 .009m.709-.279a13.82 13.82 0 1 1-17.806-8.054 13.71 13.71 0 0 1 17.806 8.054",
    className: "cls-10",
    transform: "translate(-.005 -.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    d: "M139.279 54.551l.27.713a10.4 10.4 0 0 0-6.06 13.4l-.713.269a11.158 11.158 0 0 1 6.5-14.377",
    className: "cls-10",
    transform: "translate(-.006 -.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    fill: "#37a7f4",
    d: "M150.776 78.714a15.735 15.735 0 0 0 7.1-19.252 15.688 15.688 0 0 0-20.186-9.132 15.668 15.668 0 0 0 8.91 29.959l.323-.071 1.62 4.3-.385.145 6.666 17.678a2.315 2.315 0 0 0 4.333-1.634L152.49 83.03l-.384.145-1.62-4.3zm-2.684-.79a13.833 13.833 0 1 1 7.711-7.239 13.842 13.842 0 0 1-7.711 7.239",
    transform: "translate(-.005 -.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    d: "M158.592 59.194a16.449 16.449 0 0 0-21.17-9.577 16.429 16.429 0 0 0 9.021 31.483l8.02 21.275a2.7 2.7 0 1 0 5.045-1.9l-8.076-21.251a16.508 16.508 0 0 0 7.16-20.028m-.924 44.04a1.937 1.937 0 0 1-2.492-1.127l-8.251-21.889-.323.071a15.668 15.668 0 0 1-8.914-29.958 15.688 15.688 0 0 1 20.189 9.133 15.735 15.735 0 0 1-7.1 19.251l-.289.162 8.309 21.865a1.937 1.937 0 0 1-1.128 2.493",
    className: "cls-10",
    transform: "translate(-.005 -.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    d: "M142.209 88.883l9.726-7.524a2.386 2.386 0 0 1 1.928-.387c.695.168 1.026.7 1.427 1.238l-8.226 6.1a5.165 5.165 0 0 1 .979 5.24",
    className: "cls-8",
    transform: "translate(-.006 -.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    d: "M142.209 88.883l9.726-7.524a2.386 2.386 0 0 1 1.928-.387c.695.168 1.026.7 1.427 1.238l-8.226 6.1a5.165 5.165 0 0 1 .979 5.24",
    className: "cls-9",
    transform: "translate(-.006 -.003)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    d: "M55.282 48.293a11.139 11.139 0 0 1 2.979-4.325 8.112 8.112 0 0 1 4.177-1.663q1.135-.148 2.461-.241a11.685 11.685 0 0 0 2.623-.492 8.109 8.109 0 0 0 2.44-1.24 6 6 0 0 0 1.868-2.507 6.444 6.444 0 0 0 .6-2.791 6.035 6.035 0 0 0-2.058-4.376 7.949 7.949 0 0 0-2.117-1.349 8.113 8.113 0 0 0-4.922-.562 9.656 9.656 0 0 0-4.324 2l-1.528-2.271a10.188 10.188 0 0 1 2.7-1.771 10.894 10.894 0 0 1 3.022-.854 11.391 11.391 0 0 1 3.145.031 12.066 12.066 0 0 1 3.071.881 11.263 11.263 0 0 1 3.015 1.927 8.771 8.771 0 0 1 2.118 2.823 8.584 8.584 0 0 1 .806 3.562 9.808 9.808 0 0 1-.9 4.1 8.6 8.6 0 0 1-1.84 2.813 7.6 7.6 0 0 1-2.3 1.541 9.81 9.81 0 0 1-2.634.7q-1.387.172-2.787.314-1.006.1-1.932.256a6.045 6.045 0 0 0-1.834.648 6.136 6.136 0 0 0-1.716 1.421 10.042 10.042 0 0 0-1.513 2.555zm-.553 6.325a1.832 1.832 0 1 0-1.829-1.832 1.832 1.832 0 0 0 1.832 1.832",
    className: "cls-10",
    transform: "translate(-.002 -.001)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMan);
export default __webpack_public_path__ + "static/media/searchMan.352d4ff019eb1c0a34145c7e49c41f47.svg";
export { ForwardRef as ReactComponent };